module.exports = __webpack_public_path__ + "static/media/calendar-avatar.7a033563.svg";